module.exports = __webpack_public_path__ + "static/media/jef-video.7933fc05.gif";